import React, { Suspense } from 'react';
// import InitialLoading from '../../components/common/InitialLoading';
// import { CircularProgress, Backdrop } from '@mui/material';

// const Loadable = (Component) => (props) =>
// (
//   <Suspense fallback={<InitialLoading />}>
//     <Component {...props} />
//   </Suspense>
// );

const Loadable = (lazyComponent: any) => {
  const LazyComponent = React.lazy(lazyComponent);

  return (props: any) => (
    <Suspense
      fallback={
        <div className="h-screen flex justify-center items-center bg-black/50 backdrop-blur-sm text-white text-2xl max-w-[600px] w-full mx-auto z-10">
          {/* <div className="flex flex-col items-center">
          <div className="mt-5 text-center">
            TW Loader
          </div>
        </div> */}
          <div className="fixed inset-0 flex items-center justify-center z-99 bg-black/50 max-w-[500px] mx-auto">
            <span className="loading loading-spinner text-(--button-green) w-[50px]"></span>
          </div>
        </div>
      }
    >
      <LazyComponent {...props} />
    </Suspense>
  );
};

export default Loadable;
